import { FormikProps } from 'formik'
import { useMemo } from 'react'
import { MaskType } from '_metronic/helpers'
import { FormInput, FormSelect } from 'app/components'
import { useT } from '_metronic/i18n/Metronici18n'
import { opcoesTipoTelefone } from './tipoTelefone'

type IProps<V> = {
  formik: FormikProps<V>
  /** Prefixo dos campos no formik (`funcionario.`). */
  prefixo: string
  idPrefix: string
}

/** "Tipo" + "Telefone" lado a lado (SBIS ECF.02.01). O DDD já vem separado pela máscara. */
export const TelefoneComTipoFields = <V,>({ formik, prefixo, idPrefix }: IProps<V>) => {
  const { t } = useT()
  const opcoes = useMemo(() => opcoesTipoTelefone(t), [t])

  return (
    <div className='row'>
      <div className='col-5'>
        <FormSelect
          formik={formik}
          name={`${prefixo}tipoTelefone`}
          inputId={`${idPrefix}-tipoTelefone`}
          label={t('tipo_telefone.label')}
          options={opcoes}
          isDisabled={formik.isSubmitting}
        />
      </div>
      <div className='col-7'>
        <FormInput
          formik={formik}
          name={`${prefixo}telefone`}
          entity='telefone'
          mask={MaskType.Phone}
        />
      </div>
    </div>
  )
}
